import React from "react";
import { Dialog } from "@headlessui/react";
import { MdClose } from "react-icons/md";

const ImageModal = ({ isOpen, onClose, imageUrl, title = "Attachment" }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {}} // Disable closing by clicking outside
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />

        <div className="relative bg-white rounded-lg max-w-4xl max-h-screen overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b">
            <Dialog.Title className="text-lg font-medium">
              {title}
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <MdClose className="w-6 h-6" />
            </button>
          </div>

          <div className="p-4">
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Attachment"
                className="max-w-full h-auto max-h-96 mx-auto"
              />
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ImageModal;
